<header class="topbar">
  <div class="header-toolbar">
    <div class="toolbar-before">
      <button
        type="button"
        class="toolbar-button menu-button"
        aria-controls="app-sidebar"
        [attr.aria-expanded]="menuOpened"
        [attr.aria-label]="'common.nav.menu' | translate"
        [title]="'common.nav.menu' | translate"
        (click)="toggle()"
      >
        <i class="app-icon fa-solid fa-bars" aria-hidden="true"></i>
      </button>
      <a class="header-title" routerLink="/home">{{ appName }}</a>
      <div class="toolbar-item search-item w3-hide-small">
        @if (!showMobileSearch) {
          <ng-container
            [ngTemplateOutlet]="companySearch"
            [ngTemplateOutletContext]="{ width: '360px' }"
          ></ng-container>
        }
      </div>
    </div>
    <div class="toolbar-after">
      <div class="toolbar-item w3-hide-medium w3-hide-large">
        <button
          type="button"
          class="toolbar-button search-toggle"
          [title]="'globalSearch.label.aria' | translate"
          [attr.aria-label]="'globalSearch.label.aria' | translate"
          [attr.aria-expanded]="showMobileSearch"
          (click)="showMobileSearch = !showMobileSearch"
        >
          <i class="app-icon fa-solid fa-magnifying-glass"></i>
        </button>
      </div>
      <div class="toolbar-item">
        <button
          matButton="outlined"
          type="button"
          class="new-list-button"
          [title]="'common.nav.newList' | translate"
          [attr.aria-label]="'common.nav.newList' | translate"
          (click)="editorActive = true"
        >
          <i class="fa-solid fa-plus" aria-hidden="true"></i>
          <span class="new-list-label">{{
            'common.nav.newList' | translate
          }}</span>
        </button>
      </div>
      <div class="toolbar-item user-options">
        <button
          type="button"
          class="toolbar-button user-button"
          title="Settings"
          [attr.aria-label]="'common.nav.account' | translate"
          [matMenuTriggerFor]="optionsMenu"
        >
          <span class="user-avatar" aria-hidden="true">
            <i class="fa-solid fa-user"></i>
          </span>
          <span class="user-name w3-hide-small">{{ userName$ | async }}</span>
          <i
            class="fa-solid fa-chevron-down user-chevron"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>
  </div>
  @if (showMobileSearch) {
    <div class="mobile-search w3-hide-medium w3-hide-large">
      <ng-container
        [ngTemplateOutlet]="companySearch"
        [ngTemplateOutletContext]="{ width: '100%' }"
      ></ng-container>
    </div>
  }
</header>

<mat-menu
  #optionsMenu="matMenu"
  xPosition="before"
  class="app-menu options-menu-dropdown"
>
  <div
    class="theme-group"
    role="group"
    [attr.aria-label]="'common.theme.label' | translate"
  >
    <div class="theme-label" aria-hidden="true">
      {{ 'common.theme.label' | translate }}
    </div>
    @for (option of themeOptions; track option.value) {
      <button
        mat-menu-item
        role="menuitemradio"
        class="theme-option"
        [attr.aria-checked]="theme.preference() === option.value"
        (click)="theme.set(option.value)"
      >
        <i [ngClass]="option.icon" aria-hidden="true"></i>
        <span>{{ option.label | translate }}</span>
        @if (theme.preference() === option.value) {
          <i class="fa-solid fa-check theme-check" aria-hidden="true"></i>
        }
      </button>
    }
  </div>
  <div class="menu-separator" role="separator"></div>
  @for (item of optionItems; track item) {
    @if (item.url) {
      <a mat-menu-item [href]="item.url" [target]="item.target">
        <i [ngClass]="item.icon || ''" aria-hidden="true"></i>
        <span>{{ item.label | translate }}</span>
      </a>
    } @else {
      <button mat-menu-item (click)="item.command?.()">
        <i [ngClass]="item.icon || ''" aria-hidden="true"></i>
        <span>{{ item.label | translate }}</span>
      </button>
    }
  }
</mat-menu>

<app-list-editor
  [(editorActive)]="editorActive"
  [list]="null"
></app-list-editor>
<app-shortcut-help></app-shortcut-help>

<ng-template #companySearch let-width="width">
  <app-global-search [style.width]="width"></app-global-search>
</ng-template>
